import { Select } from "@normasteaching/norma-ui";
import {
  presetRange,
  STATS_PERIOD_OPTIONS,
  StatsPeriod,
  StatsPeriodPreset,
} from "./statsPeriod.ts";

const DATE_INPUT_CLASS_NAME =
  "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500";

type Props = {
  period: StatsPeriod;
  onChange: (period: StatsPeriod) => void;
  options?: { id: StatsPeriodPreset; name: string }[];
};

export function PeriodSelector({
  period,
  onChange,
  options = STATS_PERIOD_OPTIONS,
}: Props) {
  const onPresetChange = (id: string | null) => {
    const preset = (id ?? "last30") as StatsPeriodPreset;
    onChange({
      preset,
      range: preset === "custom" ? period.range : presetRange(preset),
    });
  };

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="w-48 space-y-1">
        <p className="text-sm font-medium text-gray-700">Periodo</p>
        <Select
          value={period.preset}
          onChange={onPresetChange}
          options={options}
        />
      </div>
      {period.preset === "custom" && (
        <>
          <div className="space-y-1">
            <p className="text-sm font-medium text-gray-700">Dal</p>
            <input
              type="date"
              value={period.range.fromDay}
              max={period.range.toDay}
              onChange={(e) =>
                onChange({
                  ...period,
                  range: { ...period.range, fromDay: e.target.value },
                })
              }
              className={DATE_INPUT_CLASS_NAME}
            />
          </div>
          <div className="space-y-1">
            <p className="text-sm font-medium text-gray-700">Al</p>
            <input
              type="date"
              value={period.range.toDay}
              min={period.range.fromDay}
              onChange={(e) =>
                onChange({
                  ...period,
                  range: { ...period.range, toDay: e.target.value },
                })
              }
              className={DATE_INPUT_CLASS_NAME}
            />
          </div>
        </>
      )}
    </div>
  );
}
